module.exports = __webpack_public_path__ + "img/1800-1_YR_2022_Phishing.2412d0d7.png";